import { useViewedTenantAccount } from '../../../hooks/useViewedTenantAccount';
import type { Season } from '../../../api/organization/allocationWindowTypes';

/**
 * The tenant's series season (Services → Use cases), as the season a new
 * window and the allocations tab start from (PO 2026-10-24, Q4 A). Read for
 * the VIEWED tenant, so a master looking at another tenant gets that tenant's.
 * null when unset: the fields then start empty rather than with a made-up season.
 */
export const useSeriesSeason = (): Season | null => {
    const { accountTenant } = useViewedTenantAccount({ withPaymentIntegration: false });
    const season = accountTenant?.seriesSeason;
    return season ? { from: season.startDate, to: season.endDate } : null;
};

export default useSeriesSeason;
